var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"tab-pane"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }